import { NavigationMode, SelectionPanelModel } from "@gsa-sam/components";
import { environment } from 'environment';

export let NavigationConfig = {
  getNavigationPanelConfig: (): SelectionPanelModel => {
    let followedRecords = {
      id: 'followedRecords',
      text: 'Followed Records',
      route: '/following',
      queryParams: {},
      mode: NavigationMode.INTERNAL
    };

    let largeDownloads = {
      id: 'largeDownloads',
      text: 'Large Downloads',
      route: '/downloads',
      queryParams: {},
      mode: NavigationMode.INTERNAL
    };

    let emailSettings = {
      id: 'emailSettings',
      text: 'Email Settings',
      route: '/email-settings',
      queryParams: {},
      mode: NavigationMode.LABEL
    };
    let accountDetails = {
      id: 'accountDetails',
      text: 'Account Details',
      route: '/account-details',//'/profile/details?isShowContractData=true',
      queryParams: {},
      mode: NavigationMode.LABEL
    };
    let roles = {
      id: 'roles',
      text: 'Roles',
      route: '/roles',//'/profile/access?isShowContractData=true',
      queryParams: {},
      mode: NavigationMode.LABEL
    };
    let termsOfUse = {
      id: 'termsOfUse',
      text: 'Terms of Use',
      route: '/terms-of-use',
      queryParams: {},
      mode: NavigationMode.LABEL
    };
    let navigationPanelConfig: SelectionPanelModel = {
      selectionMode: "NAVIGATION",
      navigationLinks: [
      ]
    }

    if (environment.SHOW_ACCOUNT_DETAILS === "true") {
      navigationPanelConfig.navigationLinks.push({ ...accountDetails });
    }

    if (environment.SHOW_ROLES === "true") {
      navigationPanelConfig.navigationLinks.push({ ...roles });
    }

    navigationPanelConfig.navigationLinks.push({ ...followedRecords });

    if (environment.SHOW_LARGEDOWNLOAD === "true") {
      navigationPanelConfig.navigationLinks.push({ ...largeDownloads });
    }

    if (environment.SHOW_EMAIL_SETTINGS === "true") {
      navigationPanelConfig.navigationLinks.push({ ...emailSettings });
    }

    if (environment.SHOW_TERMS === "true") {
      navigationPanelConfig.navigationLinks.push({ ...termsOfUse });
    }

    return navigationPanelConfig;
  }
};
/*export let NavigationPanelConfig: SelectionPanelModel = {
  selectionMode: "NAVIGATION",
  navigationLinks: [
    // {
    //   id: 'workspaceHome',
    //   text: 'Workspace Home',
    //   route: '/',
    //   queryParams: {},
    //   mode: NavigationMode.INTERNAL,
    //   children: []
    // },
    // {
    //   id: 'entityInformation',
    //   text: 'Entity Information',
    //   route: '#',
    //   queryParams: {},
    //   mode: NavigationMode.LABEL
    // },
    // {
    //   id: 'entityReporting',
    //   text: 'Entity Reporting',
    //   route: '#',
    //   queryParams: {},
    //   mode: NavigationMode.LABEL
    // },
    // {
    //   id: 'userDirectory',
    //   text: 'User Directory',
    //   route: '#',
    //   queryParams: {},
    //   mode: NavigationMode.LABEL
    // },
    {
      id: 'profile',
      text: 'Profile',
      route: '#',
      queryParams: {},
      mode: NavigationMode.LABEL,
      children: [
        // {
        //   id: 'accountDetails',
        //   text: 'Account Details',
        //   route: '#',
        //   queryParams: {},
        //   mode: NavigationMode.LABEL
        // },
        // {
        //   id: 'roles',
        //   text: 'Roles',
        //   route: '#',
        //   queryParams: {},
        //   mode: NavigationMode.LABEL
        // },
        {
          id: 'followedRecords',
          text: 'Followed Records',
          route: '/following',
          queryParams: {},
          mode: NavigationMode.INTERNAL
        },
        {
          id: 'largeDownloads',
          text: 'Large Downloads',
          route: '/downloads',
          queryParams: {},
          mode: NavigationMode.INTERNAL
        },
        {
          id: 'emailSettings',
          text: 'Email Settings',
          route: '/email-settings',
          queryParams: {},
          mode: NavigationMode.LABEL
        },
        // {
        //   id: 'dataServices',
        //   text: 'Data Services',
        //   route: '#',
        //   queryParams: {},
        //   mode: NavigationMode.LABEL
        // },
        // {
        //   id: 'history',
        //   text: 'History',
        //   route: '#',
        //   queryParams: {},
        //   mode: NavigationMode.LABEL
        // }
      ]
    }]
};*/
